import React from 'react'
import { Provider } from 'react-redux'

import { Modals } from 'components/Modals'

import { AppRouter } from 'router/AppRouter'
import { StoreProvider } from 'contexts/StoreContext'
import { store } from 'store'
import { store as rtkStore } from 'redux/store'
import 'styles/globals.scss'

const App: React.FC = () => {
  return (
    <StoreProvider store={store}>
      <Provider store={rtkStore}>
        <div className="content">
          <AppRouter />
        </div>
        <Modals />
      </Provider>
    </StoreProvider>
  )
}

export default App
